import axios from 'axios';

const RESSOURCE_NAME = 'articles_retour';

export default {

    getArticlesRetour(nbResult = "", query = "" ) {
        return axios.post(`${RESSOURCE_NAME}/`, { query: query, limit: nbResult })
    },
}